const scroll_to_top = () => {
    const backToTopBtn = document.querySelector('.back-to-top-btn');
    backToTopBtn.addEventListener('click', () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
}
export default scroll_to_top;